export class GridFlavorBase {

    // buttons that all grid flavors have
    protected gridCommandButtons: string[] = ['edit', 'save', 'cancel'];


    public usesButton(button: string, rowIsDisabled: boolean): boolean {
        return this.gridCommandButtons.indexOf(button) > -1;
    }

    // This is a kendo grid setting where scrollable = "virtual" sets up the grid for infinite scrolling
    // This is the default, but other flavors can set a different mode
    public scrollMode(): string {
        return "virtual";
    }
}
